var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.resourceId},[(_vm.o)?_vm._t("default",null,null,{ o: _vm.o }):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }